import { h, svgUse } from '../utils/dom.js';
import { t } from '../i18n/index.js';

export function AboutPage() {
  return h('div', { class: 'page active about-page' },
    h('section', { class: 'about-hero' },
      h('div', { class: 'about-hero-copy' },
        h('span', { class: 'eyebrow' }, t('aboutEyebrow')),
        h('h1', {}, t('aboutTitle')),
        h('p', {}, t('aboutDesc')),
        h('div', { class: 'about-highlights' },
          highlight('ic-gamepad', t('aboutHighlightGame')),
          highlight('ic-books', t('aboutHighlightScenarios')),
          highlight('ic-bulb', t('aboutHighlightFeedback')),
        ),
      ),
      h('div', { class: 'about-mascot-stage', 'aria-hidden': 'true' },
        h('span', { class: 'about-orbit about-orbit-one' }, svgUse('ic-leaf')),
        h('span', { class: 'about-orbit about-orbit-two' }, svgUse('ic-gamepad')),
        h('span', { class: 'about-orbit about-orbit-three' }, svgUse('ic-flask')),
        h('img', { src: '/ludus-study-companion.png', alt: '' }),
      ),
    ),

    h('section', { class: 'about-purpose-grid' },
      purposeCard('mission', 'ic-target', t('missionTitle'), t('missionText')),
      purposeCard('vision', 'ic-eye', t('visionTitle'), t('visionText')),
    ),

    h('section', { class: 'about-values' },
      h('div', { class: 'about-values-head' },
        h('span', { class: 'eyebrow' }, t('valuesEyebrow')),
        h('h2', {}, t('valuesTitle')),
      ),
      h('div', { class: 'about-values-grid' },
        valueCard('ic-bulb', t('curiosityT'), t('curiosityD'), 'green'),
        valueCard('ic-users', t('inclusionT'), t('inclusionD'), 'purple'),
        valueCard('ic-gear', t('innovationT'), t('innovationD'), 'blue'),
        valueCard('ic-heart', t('impactT'), t('impactD'), 'red'),
      ),
    ),
    h('p', { class: 'tagline-strip' }, t('tagline')),
  );
}

function highlight(icon, label) {
  return h('span', {}, svgUse(icon), label);
}

function purposeCard(kind, icon, title, text) {
  return h('article', { class: `purpose-card ${kind}` },
    h('span', { class: 'purpose-icon' }, svgUse(icon)),
    h('div', {}, h('h2', {}, title), h('p', {}, text)),
  );
}

function valueCard(icon, title, desc, tone) {
  return h('article', { class: `about-value-card ${tone}` },
    h('span', { class: 'about-value-icon' }, svgUse(icon)),
    h('strong', {}, title),
    h('p', {}, desc),
  );
}
